<div *ngIf="isCollapsed" fxLayout="column" fxLayoutAlign="start center" class="app-menu collapsed pt-24">
    <ng-container *ngTemplateOutlet="menuContent; context: {collapsed: true}">
    </ng-container>
</div>

<div *ngIf="!isCollapsed" fxLayout="column" fxLayoutAlign="start" class="app-menu pt-24">
    <ng-container *ngTemplateOutlet="menuContent; context: {collapsed: false}">
    </ng-container>
</div>

<ng-template #menuContent let-collapsed="collapsed">
    <ng-container *ngIf="isAdvUser|async as isAdvUser">
        <div *ngIf="!isAdvUser.value" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px" class="mb-20 dev-dashboard-row">
            <button *ngIf="mode === MenuMode.ENERGY_COMMUNITY" app-icon-button class="dev-dashboard-button"
                    [title]="'Supervision dashboard'|i18n"
                    (click)="onClickDevDashboard()">
                <app-icon name="fal-sign-out-alt" [faRotate]="180"></app-icon>
            </button>
            <div *ngIf="!collapsed && !!ecResource" class="txt-h-16-7 contrast">
                {{ecResource.name}}
            </div>
        </div>

        <ng-container *ngFor="let entry of entries; trackBy: trackByIndex">
            <ng-container *ngIf="isAdvUser.value && entry.name !== MENU_TITLES.SUBJECTS || !isAdvUser.value">
                <button *appVar="isActive(entry) as active" class="menu-item selected-item"
                        [ngClass]="{'active': active}"
                        [title]="entry.name|i18n"
                        [disabled]="active"
                        (click)="onClickEntry(entry)">
                    <div fxLayout="row" [ngClass]="{'collapsed': collapsed}">
                        <app-icon [name]="entry.icon" class="item-icon">
                        </app-icon>
                        <span *ngIf="!collapsed" class="txt-h-16-4 ml-24 lighter-label">{{entry.name|i18n}}</span>
                    </div>
                </button>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-template>
